const LODESTAR_QUESTIONS_TEST_ID_SCOPE = 'lodestar-questions';

export const LodeStarQuestionsTestIds = {
  ROOT: LODESTAR_QUESTIONS_TEST_ID_SCOPE,
  TITLE: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.title`,
  DESCRIPTION: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.description`,
  FORM: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.form`,
  SAVE_BUTTON: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.save-button`,
  RESET_BUTTON: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.reset-button`,
  EMPTY_STATE: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.empty-state`,
  RECALCULATE_CANCEL_BUTTON: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.recalculate-cancel-button`,
  RECALCULATE_SKIP_BUTTON: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.recalculate-skip-button`,
  RECALCULATE_CONFIRM_BUTTON: `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.recalculate-confirm-button`,
  getFieldId: identifier => `${LODESTAR_QUESTIONS_TEST_ID_SCOPE}.field-${identifier}`,
};
